import React from 'react';
import { useModal } from '../../context/ModalContext';
import './ToolsSection.css';

const ToolsSection = () => {
  const { openModal } = useModal();
  const urlDeConect = 'http://www.digitalfactura.com/contenido/sicai/downloads/Instalador_DeConect.exe';
  const urlSicaiXml = 'http://digitalfactura.com/contenido/sicai/downloads/SicaiXML.exe';

  return (
    <section className="df-tools-section" id="deconect">
      <div className="df-tools-container">
        {/* Tarjeta 1: DECONECT (Tarjeta Blanca Oficial) */}
        <div className="df-tool-card df-tool-card-light">
          <span className="df-tool-tag">DECONECT</span>

          <h3 className="df-tool-title">
            Convierte y timbra tus comprobantes versión 3.2 y 3.3 a 4.0
          </h3>

          <p className="df-tool-desc">
            Una solución que te permite seguir generando tus comprobantes a partir de formatos anteriores. Olvida las actualizaciones costosas y los cambios en tu forma de trabajo: DeConect convierte y timbra tus comprobantes a la versión actual de XML y genera el PDF.
          </p>

          <p className="df-tool-highlight">
            Con DeConect estarás siempre actualizado.
          </p>

          <div className="df-tool-actions">
            <a
              href={urlDeConect}
              download=""
              className="df-tool-btn-download"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 4v11M7 10l5 5 5-5M5 20h14"></path>
              </svg>
              Descarga ahora
            </a>

            <button
              type="button"
              className="df-tool-link-more"
              onClick={() => openModal('deconect')}
            >
              Conoce más
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h14M13 6l6 6-6 6"></path>
              </svg>
            </button>
          </div>
        </div>

        {/* Tarjeta 2: DESCARGA MASIVA (Tarjeta Oscura Oficial) */}
        <div className="df-tool-card df-tool-card-dark">
          <span className="df-tool-tag df-tool-tag-accent-dark">DESCARGA MASIVA</span>

          <h3 className="df-tool-title df-tool-title-dark">
            Descarga todos tus comprobantes emitidos y recibidos
          </h3>

          <p className="df-tool-desc df-tool-desc-dark">
            Administra los comprobantes que descargas del SAT desde la aplicación y expórtalos a Excel. Fácil de usar: hasta 2,000 comprobantes por día por cada RFC con el que ingreses.
          </p>

          {/* Grilla de 2 Licencias de Precio */}
          <div className="df-tool-pricing-grid">
            <div className="df-tool-price-card">
              <span className="df-tool-price-tag">Versión Multi RFC</span>
              <span className="df-tool-price-val">$4,202.68</span>
              <span className="df-tool-price-sub">Licencia anual · IVA incluido</span>
            </div>

            <div className="df-tool-price-card">
              <span className="df-tool-price-tag">Versión Mono RFC</span>
              <span className="df-tool-price-val">$2,204.00</span>
              <span className="df-tool-price-sub">Licencia anual · IVA incluido</span>
            </div>
          </div>

          <a
            href={urlSicaiXml}
            download=""
            className="df-tool-btn-download df-tool-btn-download-dark"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 4v11M7 10l5 5 5-5M5 20h14"></path>
            </svg>
            Descarga ahora
          </a>
        </div>
      </div>
    </section>
  );
};

export default ToolsSection;
